import { type Event } from '@kalos/kalos-rpc';

import { getJobTypeBreakdown } from '../../ServiceCalendar/components/utils';

type StatusCount = {
  count: number;
  breakdown: ReturnType<typeof getJobTypeBreakdown>;
};

/** Counts + per-job-type breakdowns for a day, shaped as <CallWindowBreakout /> props. */
export type DateStatusBreakout = {
  total: StatusCount;
  completed: StatusCount;
  confirmed: StatusCount;
  pending: StatusCount;
};

/**
 * Build the breakout pill data for a single day. Pass the events already scoped to the
 * date and excluding Canceled. Shared by the week-view column header and the Schedule
 * Call "Select Time Window" header so both show identical numbers for the same date.
 */
export const getDateStatusBreakout = (dateEvents: Event[]): DateStatusBreakout => {
  const completed = dateEvents.filter((e) => e.logJobStatus === 'Completed');
  const confirmed = dateEvents.filter((e) => e.logJobStatus === 'Confirmed');
  const pending = dateEvents.filter((e) => e.logJobStatus === 'Pend Sched');
  return {
    total: { count: dateEvents.length, breakdown: getJobTypeBreakdown(dateEvents) },
    completed: { count: completed.length, breakdown: getJobTypeBreakdown(completed) },
    confirmed: { count: confirmed.length, breakdown: getJobTypeBreakdown(confirmed) },
    pending: { count: pending.length, breakdown: getJobTypeBreakdown(pending) },
  };
};
